import { Variant } from '@trwl/backend.api';
import { createEvent, createStore } from 'effector';

export const $variant = createStore<Variant | null>(null);
export const $setVariant = createEvent<Variant | null>();

$variant.on($setVariant, (_, value) => value);
